module.exports = __webpack_public_path__ + "img/protected.7f7c56c0.png";